import { camelToSnake, snakeToCamel } from "caseparser";
import { api } from "@/app/app.api";
import { Exercise } from "@/app/exercises/exercises";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import i18n from "@/app/i18n";
import { Paginator } from "@/shared/utils/paginator";

export const exercisesApi = api
  .enhanceEndpoints({ addTagTypes: ["exercises", "Exercise"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      exercises: builder.query({
        query: ({ search, muscle, type, branchId, page, equipment }) => ({
          url: `admin/exercises/search`,
          method: RequestMethod.GET,
          params: camelToSnake({
            search: search ? search : undefined,
            muscle,
            type,
            page,
            branchId,
            equipment,
          }),
        }),
        transformResponse: (response: any): Paginator<Exercise> =>
          snakeToCamel(response),
        providesTags: ["exercises", "Exercise"],
      }),

      disclaimer: builder.query({
        query: ({ firstAlternative }) => ({
          url: `disclaimer?first_alternative=${firstAlternative}`,
          method: RequestMethod.GET,
          headers: {
            lang: i18n.language,
          },
        }),
        transformResponse: (response: any): Array<Exercise> | null => response,
        providesTags: ["exercises", "Exercise"],
      }),
    }),
  });

export const { useExercisesQuery, useDisclaimerQuery } = exercisesApi;
